/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetDataCountWidgetData
 */
export interface WidgetDataCountWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataCountWidgetData
     */
    $type?: WidgetDataCountWidgetDataTypeEnum;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetDataCountWidgetData
     */
    total: ApiUserTasksGetPageParameter;
}


/**
 * @export
 */
export const WidgetDataCountWidgetDataTypeEnum = {
    Count: 'count'
} as const;
export type WidgetDataCountWidgetDataTypeEnum = typeof WidgetDataCountWidgetDataTypeEnum[keyof typeof WidgetDataCountWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataCountWidgetData interface.
 */
export function instanceOfWidgetDataCountWidgetData(value: object): value is WidgetDataCountWidgetData {
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function WidgetDataCountWidgetDataFromJSON(json: any): WidgetDataCountWidgetData {
    return WidgetDataCountWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataCountWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataCountWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
    };
}

export function WidgetDataCountWidgetDataToJSON(json: any): WidgetDataCountWidgetData {
    return WidgetDataCountWidgetDataToJSONTyped(json, false);
}

export function WidgetDataCountWidgetDataToJSONTyped(value?: WidgetDataCountWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
    };
}

